import Vue from 'vue'
import NToast from '../components/ui/n-toast.vue'
import DemandBtn from '../components/common/demand-btn.vue'

Vue.component('n-toast', NToast)
Vue.component('demand-btn', DemandBtn)


// WEBPACK FOOTER //
// ./src/utils/global-component.js